"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("react");
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
require("../../../assets/css/index.css");
exports.default = (function (props) { return ((0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, __assign({ hideProgressBar: true, position: "bottom-center", closeOnClick: true, pauseOnFocusLoss: true, pauseOnHover: true }, props))); });
